import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {
    DragData,
    DragViewState,
    DropViewState,
    createDragViewState,
    createDropViewState,
} from 'owa-dnd';
import type { SubTaskViewProps, SubTaskDragData } from '../schema';
import SubTaskView from '../components/SubTaskView';
import {
    useOnDrop,
    canDropSubtask,
    useOnDragOver,
    useOnDragLeave,
    SUBTODO_DRAG_TYPE,
} from './subtaskDroppable';

export default function useSubTaskDraggableViewState(props: SubTaskViewProps) {
    const [dropViewState, setDropViewState] = React.useState<DropViewState>(createDropViewState());
    const [dragViewState] = React.useState<DragViewState>(createDragViewState());

    const onDrop = useOnDrop(props.parentTaskId, props.subtaskId);
    const onDragOver = useOnDragOver(setDropViewState);
    const onDragLeave = useOnDragLeave(setDropViewState);

    const getDragData = React.useCallback(() => {
        const { parentTaskId, subtaskId } = props;
        return {
            itemType: SUBTODO_DRAG_TYPE,
            itemData: {
                parentTaskId: parentTaskId,
                subtaskId: subtaskId,
            } as SubTaskDragData,
        } as DragData;
    }, [props.parentTaskId, props.subtaskId]);

    const getDragPreview = React.useCallback(() => {
        const elem = document.createElement('div');
        ReactDOM.render(<SubTaskView {...props} />, elem);
        return elem;
    }, [props]);

    return {
        droppableProps: {
            dropViewState: dropViewState,
            onDrop: onDrop,
            canDrop: canDropSubtask,
            onDragOver: onDragOver,
            onDragLeave: onDragLeave,
        },
        draggableProps: {
            dragViewState: dragViewState,
            getDragData: getDragData,
            getDragPreview: getDragPreview,
            onMouseDown: preventAssetDrag,
            onPointerDown: preventAssetDragPointer,
        },
    };
}

function preventAssetDrag(mouseDownEvent: MouseEvent) {
    mouseDownEvent.stopPropagation();
}

function preventAssetDragPointer(pointerDownEvent: PointerEvent) {
    if (pointerDownEvent.isPrimary) {
        pointerDownEvent.stopPropagation();
    }
}
